<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
  beforeMount () {

  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Alexandria&family=Concert+One&family=El+Messiri&family=Lalezar&family=Marhey&family=Montserrat:wght@500&family=PT+Sans+Narrow&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;800&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Chango&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Alexandria:wght@900&display=swap');
.arabic-bold{
  font-family: 'Cairo', sans-serif !important;
  font-weight: 800 !important;
  line-height: inherit !important;
  letter-spacing: 0.01cap;
}
.english {
  font-family: "Alexandria", sans-serif;
  font-weight: 400;
  font-style: normal;
}
.arabic{
  font-family:'Cairo', sans-serif !important;
  font-weight: 400;
  line-height: inherit !important;
  letter-spacing: 0.01cap;
}
</style>
